import { useState } from 'react';
import { useTranslation } from '@/i18n/hook';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const { t, i18n } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const currentLang = i18n.language;

  const getQuestion = (item: typeof faqItems[0]) => {
    if (currentLang === 'de') return item.questionDe;
    if (currentLang === 'en') return item.questionEn;
    return item.question;
  };

  const getAnswer = (item: typeof faqItems[0]) => {
    if (currentLang === 'de') return item.answerDe;
    if (currentLang === 'en') return item.answerEn;
    return item.answer;
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
          {t('faq.h2')}
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="font-medium text-foreground-800 text-sm pr-4">{getQuestion(item)}</span>
                <i className={`ri-add-line text-foreground-500 transition-transform flex-shrink-0 ${openIdx === idx ? 'rotate-45' : ''}`} />
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{getAnswer(item)}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}